import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AppInitService {

  constructor() { }

  load(): Promise<any>  {
    return new Promise<boolean>((resolve) => {
      resolve(true);
    });
  }
}
